import { ROUTES } from "../components/shared/constant";

/**
 * Pages both product shells show (the skyAdvisor pattern: only a product's own pages choose the
 * product). Opening one of these keeps the product the user is in: a user in Performance who
 * clicks Users stays in Performance, with its sidebar, its tab pressed and its wordmark. Every
 * other path belongs to one product and makes it the active one (`/performance/**` performance,
 * everything else hire). See useActiveProduct.
 *
 * THE one list. A page added to both sidebars, or linked from the header for everyone, belongs here.
 *
 * - Users: the performance sidebar's Settings → Users links here (spec §5).
 * - Products: the staff page both sidebars draw for a platform admin (Task 18.b).
 * - Account: the header's "View profile"; the header is the same in both shells.
 * - Create tenant: the header's staff-only tenant menu link, product-neutral (review M-9).
 * - Error page and the sign-in callback: product-neutral, never a reason to change product.
 *
 * Time zone and the other profile-menu preferences are dialogs, not routes. A UI hint only: this
 * decides which shell is drawn, never what anyone may open (the route guard and the server do).
 */
export const SHARED_PATHS: readonly string[] = [
  ROUTES.ACCESS_MANAGEMENT,
  ROUTES.INSTANCE_PRODUCTS,
  ROUTES.ACCOUNT,
  ROUTES.CREATETENANT,
  ROUTES.ERRORPAGE,
  ROUTES.CALLBACK,
];

/**
 * Whether `pathname` is a shared page or beneath one, or the landing `/` itself. The landing is
 * neutral too: HomeRoute sends the user on to the active product's landing, so `/` must not pick
 * hire on its own (matched exactly; `/` is a prefix of every path).
 */
export function isSharedPath(pathname: string): boolean {
  if (pathname === ROUTES.HOME) return true;
  return SHARED_PATHS.some((base) => pathname === base || pathname.startsWith(`${base}/`));
}
